import { useCallback } from 'react';

import { githubLogin, googleLogin } from '@/services/authService';

/**
 * 社交登录 Hook
 */
export const useSocialLogin = () => {
  // GitHub 登录
  const handleGithubLogin = useCallback((ticket?: string, product?: string) => {
    try {
      githubLogin(ticket, product);
    } catch (error) {
      console.error('GitHub login error:', error);
      throw error;
    }
  }, []);

  // Google 登录
  const handleGoogleLogin = useCallback((ticket?: string, product?: string) => {
    try {
      googleLogin(ticket, product);
    } catch (error) {
      console.error('Google login error:', error);
      throw error;
    }
  }, []);

  return {
    handleGithubLogin,
    handleGoogleLogin,
  };
};
